import { create } from 'zustand'

// Open state lives here (not in the container) so chrome elsewhere — the
// top-bar search button, the sidebar search field — can open the palette.
interface CommandPaletteUIState {
  isOpen: boolean
  open: () => void
  close: () => void
  toggle: () => void
}

export const useCommandPaletteStore = create<CommandPaletteUIState>()(
  (set, get) => ({
    isOpen: false,
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false }),
    toggle: () => set({ isOpen: !get().isOpen }),
  }),
)
